<template>
  <notifications
    group="default"
    position="bottom right"
    class="mg-notify"
    width="500px"
    animationName="notify-show-animation"
  ></notifications>
</template>
<script>
import Vue from "vue";
import Notifications from "vue-notification";
Vue.use(Notifications);
export default {
  name: "MgNotifications",
};
</script>
<style lang="stylus">
.mg-notify
    padding 3px 20px
    margin 0 5px 5px
    background-color transparent
    .notification-title
        color #ffffff
        padding 15px 20px
        text-align right
    .notification-content
        color #ffffff
        font-size 16px
        padding 15px 20px
        text-align right
    .notification-title + .notification-content
        padding 0 20px 15px 20px
    &.success
        .notification-title
            background-color black
            color #ffffff

        .notification-content
            color #ffffff
            background-color black

    &.warning
        .notification-title
            color #ff4400
            background-color black


        .notification-content
            color #ff4400
            background-color black

    &.error
        .notification-title
            color #ff0000
            background-color black


        .notification-content
            color #ff0000
            background-color black

.notify-show-animation-active,
.notify-show-animation-leave-active,
.notify-show-animation-move
    transition transform .5s
    will-change transform
.notify-show-animation-enter,
.notify-show-animation-leave-to
    opacity 0
    transform translateX(500px) scale(0.2)
</style>
